// src/slices/sseSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { config } from '../constants/config';

const initialState = {
  isConnected: false,
  messages: [], // Stores messages received from the SSE
  recentMessage: {},
  userId: null, // Tracks the userId for the SSE connection
};

// Async thunk to call the server endpoint and reset messages for a specific userId
export const resetUserMessages = createAsyncThunk(
  'sse/resetUserMessages',
  async (userId, { dispatch }) => {
    try {
      // Make an HTTP request to the server to reset messages for the userId
      await axios.post(config.API_SSE_RESET_MSG_ENDPOINT, { userId });

      // Clear messages locally after server reset is successful
      dispatch(clearMessages());
    } catch (error) {
      console.error('Error resetting messages on the server:', error);
    }
  }
);

const sseSlice = createSlice({
  name: 'sse',
  initialState,
  reducers: {
    setConnected(state, action) {
      state.isConnected = action.payload;
    },
    addMessage(state, action) {
      state.messages.push(action.payload);
      state.recentMessage = action.payload;
    },
    clearMessages(state) {
      state.messages = [];
      state.recentMessage = {}; // Optionally clear recentMessage as well
    },
    setUserId(state, action) {
      state.userId = action.payload;
    },
  },
});

export const { setConnected, addMessage, clearMessages, setUserId } = sseSlice.actions;

// Selectors
export const selectIsConnected = (state) => state.user.sse.isConnected;
export const selectRecentMessage = (state) => state.user.sse.recentMessage;
export const selectMessages = (state) => state.user.sse.messages;
export const selectUserId = (state) => state.user.sse.userId;

export default sseSlice.reducer;
